import DefaultLayout from "../layouts/layout";

const layouts = {
  default: DefaultLayout,
};

export default layouts;
